import { useState } from 'react';
import { DialogActions, DialogContent, Grid, Button, Typography, FormControl } from '@mui/material';
import { DialogCustom, DialogTitleCustom, FieldWrap, IComponentCss } from '@tap/mui-ui';
import { MdEditor } from '@tap/mui-ui';
import { ICancelDialogResult, IDialogProps } from '@tap/tap-ui';
import { Link as MuiLink } from '@mui/material';
import { Link } from 'react-router';
import { IApiRelationLink, relationLinkService } from '@tap/data-providers';

/*
*   Диалог: Удалить ссылку
*/

type IRelationLinkDeleteDialogProps = IDialogProps<{ link: IApiRelationLink }, ICancelDialogResult>;

const css: IComponentCss = {
    selectedBlock: { mb: 3 },
    selectedBlockValues: {
        position: 'relative',
        paddingRight: '85px',
        backgroundColor: 'cornsilk',
        padding: '8.5px 14px',
        borderRadius: '4px',
    },
}

export default function RelationLinkDeleteDialog({
    data,
    isOpen,
    handleClose,
}: IRelationLinkDeleteDialogProps) {

    const [newComment, setNewComment] = useState<any>('');

    const handleNewCommentOnChange = ({ text }: any) => {
        setNewComment(text);
    }

    const handleCancel = () => {
        handleClose({ isCancel: true });
    }

    const handleDeleteRelationLink = () => {
        return relationLinkService.deleteRelationLink(data.link.document.documentKey, data.link.id)
            .then(() => {
                handleClose({ isCancel: false });
            });

    }


    return (
        <DialogCustom
            handleClose={handleCancel}
            open={isOpen}
        >

            <DialogTitleCustom
                primaryText={`Удалить ссылку на ${data.link.relatedDocument.documentKey}`}
            />

            <DialogContent>
                <Grid
                    item
                    container
                    spacing={2}
                    alignItems='stretch'
                >
                    <FieldWrap label={'Ссылка'} wrapStyle={css.selectedBlock}>
                        <Grid container sx={css.selectedBlockValues}>
                            <Typography component='span'>
                                <MuiLink
                                    noWrap
                                    component={Link}
                                    to={`/${data.link.relatedDocument.documentKey}`}
                                    target='_blank'
                                >
                                    {data.link.relatedDocument.documentKey}:
                                </MuiLink> {data.link.relatedDocument.title}
                            </Typography>
                        </Grid>
                    </FieldWrap>

                    <FieldWrap label={'Комментарий'}>
                        <FormControl sx={{ width: '100%' }}>
                            <MdEditor
                                onChange={handleNewCommentOnChange}
                                value={newComment}
                            />
                        </FormControl>
                    </FieldWrap>

                </Grid>
            </DialogContent>

            <DialogActions >
                <Grid container justifyContent='flex-end'>

                    <Button
                        disableElevation
                        type='button'
                        variant='contained'
                        color='primary'
                        onClick={handleDeleteRelationLink}
                        sx={{ mr: 2 }}
                    >
                        Удалить
                    </Button>

                    <Button
                        disableElevation
                        type='button'
                        variant='text'
                        color='primary'
                        onClick={handleCancel}
                    >
                        Отмена
                    </Button>

                </Grid>
            </DialogActions>

        </DialogCustom >
    );
}
